// クラシック版のエンジンの入れ物 window.chibi・charat.common（2026-10-25〜、段階 C の2。tools/chibi-unify/CLASSIC-UI.md）。
// TS の部品はほかの部品の値・関数をここから読み、自分の関数を前のエンジンと同じ名前に置く（install）。
// 旧処理（charat.legacy.js）・ページ・additional.js・セーブスロットは名前で呼ぶので、名前はそのまま（前の chibi.js・charat.common.js・画面ファイルは 7h で無くなった）

/** chibi（定数と設定は consts.ts）。ここに書くのは TS の部品が読む・置くものだけ */
export interface ChibiEngine {
  DIV_F_MAKE: string;
  DIV_F_CONTENTS: string;
  ATTR_LAYER: string;
  ATTR_SAVEVER: string | number;
  /** 保存データの並びが違うメーカー（origin・mono） */
  SAVE_FIELDS?: string[] | null;
  CACHE_DB: string;
  CACHE_DB_VAR: number;
  CACHE_TBL_CHARA: string;
  CACHE_TBL_CHARA_KEY: string;
  CACHE_USERID: string;
  CACHE_RELOAD: string;
  CACHE_GLAGREE: string;
  UserID?: string;
  isUseCache?: boolean;
  btnMenuName: { GET(encode: boolean): unknown };
  makeCharactor(chara: unknown, rnd: boolean, refresh: boolean): void;
  [name: string]: unknown;
}

/** charat.common（入れ物は charat.legacy.js の頭で作る。定数は consts.ts） */
export interface CharatCommonEngine {
  setNowMaking(show: boolean, alpha: number, delay: number, dur: number, win: string, callback?: () => void): void;
  [name: string]: unknown;
}

/** Zlib.js（common/js/deflate.min.js。クラシック版のページは前から同期の圧縮・展開に使う） */
interface ZlibLib {
  Deflate: new (data: Uint8Array) => { compress(): Uint8Array };
  Inflate: new (data: Uint8Array) => { decompress(): Uint8Array };
}

type Engines = { chibi: ChibiEngine; charat: { common: CharatCommonEngine }; Zlib: ZlibLib; mozIndexedDB?: IDBFactory; msIndexedDB?: IDBFactory; webkitIndexedDB?: IDBFactory };
const w = window as unknown as Engines;

export const chibi = (): ChibiEngine => w.chibi;
export const common = (): CharatCommonEngine => w.charat.common;
export const zlib = (): ZlibLib => w.Zlib;
/** IndexedDB（前のエンジンと同じく、ベンダーの接頭辞つきのものも見る） */
export const indexedDBOf = (): IDBFactory | undefined => window.indexedDB || w.mozIndexedDB || w.msIndexedDB || w.webkitIndexedDB;

/** 関数を、前のエンジンと同じ名前に置く（旧処理・ページなどからは今までどおり名前で呼ばれる） */
export function install(target: Record<string, unknown>, fns: Record<string, unknown>): void {
  for (const name in fns) {
    target[name] = fns[name];
  }
}
